import dayjs from 'dayjs';
import {json, JsonMappers} from '../../../core/data-source/json.mapper';
import {VehicleChecksReportListFieldsRecord} from './vehicle-checks-report-list-fields.record';

export class VehicleChecksReportListRecord {
    @json()
    reference: string;

    @json({
        mapper: {
            from: (value: any): string => dayjs.utc(value).format('DD/MM/YYYY')
        }
    })
    submissionDate: string;

    @json()
    regNumber: string;

    @json()
    driverName: string;

    @json()
    faults: number;

    //

    @json()
    odometer: any;

    @json(JsonMappers.ArrayOf(() => VehicleChecksReportListFieldsRecord))
    fields: VehicleChecksReportListFieldsRecord[];

    @json()
    signature: string;

    @json()
    signedBy: string;
}
